import React from 'react';
import { formatRupiah } from '../../utils/formatPrice';
import { assetUrl, defaultAvatarUrl, imageUrl } from '../../utils/assets';

const DEFAULT_AVATAR_URL = defaultAvatarUrl();

type Doctor = {
  name: string;
  specialization: string;
  years: number;
  rating: number;
  hospital: string;
  price_chat: number;
  price_video: number;
  originalPrice?: number;
  photoUrl: string;
  is_online?: boolean; // Optional property to indicate if the doctor is online
  is_busy?: boolean; // Slot konsultasi dokter sedang penuh (availabilityStatus BUSY)
  isMyOngoing?: boolean;
};

interface DoctorCardProps {
  doctor: Doctor;
  onConsult?: () => void;
}


const DoctorCard: React.FC<DoctorCardProps> = ({ doctor, onConsult }) => {
  const isBusy = Boolean(doctor.is_busy);
  const isDisabled = !doctor.is_online || doctor.isMyOngoing;
  
  const handleConsult = () => {
    if (isDisabled) return;
    onConsult?.();
  };
  
  return (
    <div className="flex items-center bg-white p-4 rounded-xl shadow mb-4">
      {/* Foto */}
      <div className="relative mr-4 shrink-0">
        <img
          src={imageUrl(doctor.photoUrl, DEFAULT_AVATAR_URL)}
          alt={doctor.name}
          onError={(e) => {
            e.currentTarget.src = DEFAULT_AVATAR_URL;
          }}
          className="w-16 h-16 rounded-lg object-cover"
        />
        <span
          className={`w-3 h-3 rounded-full absolute bottom-0 right-0 border-2 border-white ${
            doctor.is_online ? 'bg-green-500' : doctor.is_busy ? 'bg-amber-500' : 'bg-red-500'
          }`}
        />
      </div>

      {/* Info Dokter */}
      <div className="flex-1 min-w-0">
        {/* Nama */}
        <h4 className="font-semibold truncate">
          {doctor.name}
        </h4>

        {/* Spesialis */}
        <p className="text-sm text-gray-500 truncate">
          {doctor.specialization}
        </p>

        {/* Experience */}
        <div className="flex items-center gap-4 mt-1 text-sm text-gray-600">
          <div className="flex items-center gap-1 whitespace-nowrap">
            <img src={assetUrl('icons/briefcase.svg')} alt="Years" className="w-4 h-4" />
            <span>{doctor.years} yrs</span>
          </div>

          <div className="flex items-center gap-1 whitespace-nowrap">
            <img src={assetUrl('icons/thumb-up.svg')} alt="Rating" className="w-4 h-4" />
            <span>{doctor.rating}%</span>
          </div>
        </div>

        <p className="text-sm mt-1">
          {formatRupiah(doctor.price_chat)}
        </p>
      </div>

      {/* Tombol */}
      <div className="ml-4 shrink-0">
        <button
          className={`px-4 py-1 rounded-full text-sm whitespace-nowrap transition-opacity
            ${isBusy
              ? 'bg-amber-50 text-amber-700 border border-amber-200 cursor-not-allowed'
              : isDisabled
                ? 'text-white bg-gray-400 opacity-50'
                : 'text-white bg-morning-300 cursor-pointer'
            }`}
          onClick={handleConsult}
          disabled={isDisabled}
          aria-label={isBusy ? `Slot konsultasi ${doctor.name} sedang penuh` : undefined}
        >
          {/* {doctor.is_online ? 'Konsultasi' : 'Jadwalkan'} */}
          {isBusy ? 'Slot Penuh' : 'Konsultasi'}
        </button>
      </div>
    </div>
  );
};

export default DoctorCard;
